<app-citizen-select-form *ngIf="!codeFromUrl"></app-citizen-select-form>

<div class="citizen-view" *ngIf="citizenData">
    <section class="citizen-group" *ngFor="let group of citizenData.dataGroups">
        <header *ngIf="group.title && group.title.summary">
            <h2>{{ group.title.summary }}</h2>
        </header>

        <div class="group-content" [ngClass]="{alone: group.blocks.length === 1}">
            <article *ngFor="let block of group.blocks">
                <header *ngIf="block.title && block.title.summary">
                    <h3>{{ block.title.summary }}</h3>
                </header>

                <app-citizen-report-chart
                    *ngIf="block.chart" [reportItem]="block.chart"></app-citizen-report-chart>

                <app-citizen-partition-chart class="sunburst" id="sunburst-block"
                    *ngIf="block.partitions"
                    [mainPartition]="block.partitions"
                    [chartSize]="group.blocks.length === 1 ? 500 : 350"></app-citizen-partition-chart>

                <app-citizen-data-list
                    *ngIf="block.dataList && block.dataList.length"
                    [dataList]="block.dataList"></app-citizen-data-list>

                <div class="text-block" *ngIf="block.textArea" [innerHTML]="block.textArea"></div>
            </article>
        </div>
        <footer class="text-block" *ngIf="group.title && group.title.detail" [innerHTML]="group.title.detail"></footer>
    </section>
</div>
